import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import {Observable} from 'rxjs';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {environment} from '../../../../environments/environment';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-cell-editor-related-products',
  templateUrl: './cell-editor-related-products.component.html',
  styleUrls: ['./cell-editor-related-products.component.scss']
})
export class CellEditorRelatedProductsComponent implements ICellEditorAngularComp, OnInit, OnDestroy {
  // @ts-ignore
  @ViewChild('productInput') productInput: ElementRef<HTMLInputElement>;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  productCtrl = new FormControl('');
  private params: any;
  public filteredOptions: any;
  filteredProducts: Observable<any[]> | undefined;
  public products: any[] = [];
  currentFilter: string = 'Equals';
  private saved: boolean = false;
  @ViewChild('skuSearch') searchElement: ElementRef | undefined;

  constructor(
    private httpService: HttpService,
  ) { }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    if (!this.saved) {
      this.products = this.params.data.related_products.slice();
      this.httpService.post(environment.API_PATH + '/product/stage/edit/stop', {}).subscribe((res: any) => {});
    }
  }

  checkExist(product_id: string): boolean {
    return this.products.find((x: any) => x.product_id === product_id);
  }

  agInit(params: any): void {
    this.params = params;

    if (this.params.data.related_products.length) {
      this.products = this.params.data.related_products.slice();
    }
  }

  getValue(): any {
    return this.products;
  }

  onChange($event: any) {
    this.filteredOptions = this.httpService.post(environment.API_PATH + '/product/stage/search', {
      // sku: $event.target.value,
      sku: this.searchElement?.nativeElement.value,
      type: this.currentFilter
    });
    // console.log('onChange', $event.target.value);
  }

  save() {
    this.saved = true;
    this.httpService.post(environment.API_PATH + '/product/stage/edit/stop', {}).subscribe((res: any) => {});
    this.params.stopEditing();
  }

  cancel() {
    this.products = this.params.data.related_products.slice();
    console.log('this.params.data.related_products;', this.products);
    this.params.stopEditing();
  }

  changeFilterType(type: string): void {
    this.currentFilter = type;
    this.onChange(null);
    setTimeout(() => {
      // @ts-ignore
      this.searchElement.nativeElement.focus();
    }, 300);
  }
  displayFn = (data: any) => {
    console.log('displayFn 🔴', data);
    this.products.push(data);
    return '';
  }

  remove(product_id: string): void {
    const index = this.products.indexOf(product_id);

    if (index >= 0) {
      this.products.splice(index, 1);
    }
  }
}
